module.exports = __webpack_public_path__ + "static/logo-5eec18e6719c59f501c11f7f35c279d4.svg";